import {
    Component,
    ContentChild,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    TemplateRef,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss',
    imports: [MatIconModule, RouterModule, MatMenuModule, NgTemplateOutlet],
})
export class NavbarComponent implements OnChanges {
    @Input() activeNavItem: any;
    @Input() navItems: NavItem[] = [];
    @Output() tabChanged = new EventEmitter<number>();
    @ContentChild('menuTemplate') menuTemplate!: TemplateRef<any>;

    ngOnChanges(changes: SimpleChanges): void {
        const activeTabChange = changes['activeTab'];

        if (activeTabChange) {
            const current = this.navItems.find(
                (item) => item.id === activeTabChange.currentValue,
            );
            if (current) this.setActiveItem(current);
        }
    }

    setActiveItem(navItem: NavItem): void {
        if (!navItem.isMenu) {
            this.activeNavItem = navItem.id;
            this.tabChanged.emit(navItem.id);
        }
    }
}

export class NavItem {
    constructor(
        public id: any,
        public label: string,
        public icon: string,
        public isMenu: boolean = false,
        public menuTemplate?: TemplateRef<any>,
        public route?: string,
        public dataQa?: string,
    ) {}
}
